import React from 'react';
import classNames from 'classnames';
import ProgressBar from 'components/pure/utils/ProgressBar';
import {BarChartIcon} from '@components/icon/BarChartIcon';
import Popover from 'material-ui/Popover';
import './StatItem.styl';
import {getMuiV4Theme} from 'utils/css/themeUtils';

export default class StatItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showTrends: false,
    };
  }

  render() {
    const {
      stat,
      getLinkAndName,
      max,
      formatValue,
      title,
      color = getMuiV4Theme().palette.primary.main,
      trendColor,
      startDate,
      endDate,
      trendComponent,
      chartLabelFn,
      onOpenDrillDown,
    } = this.props;
    const {showTrends} = this.state;

    const [link, name] = getLinkAndName(stat);
    // don't show entries with no label
    if (!link) {
      console.warn("Couldn't render row for stat: ", stat);
      return null;
    }

    const chartLabel = chartLabelFn(name, title);
    // TODO find a way to avoid calling createElement here.
    const trendChart =
      showTrends &&
      React.createElement(trendComponent, {
        startDate,
        endDate,
        color: trendColor,
        formatValue,
        teamId: stat.id,
        chartLabel,
        onClose: () => this.setState({showTrends: false}),
      });

    const drilldownable = !!onOpenDrillDown && stat && stat.value > 0;

    return (
      <div className="rep-stat-item" ref={r => (this.iconRef = r)}>
        <div className="rep-name">{link}</div>
        <ProgressBar
          className={classNames({clickable: drilldownable})}
          percentage={(stat.value / max) * 100}
          color={color}
          formattedValue={formatValue(stat.value)}
          onClick={!drilldownable ? undefined : () => onOpenDrillDown && onOpenDrillDown(stat)}
        />
        <BarChartIcon
          tooltip="Over time chart"
          onClick={() => {
            if (this.props.fetchTrendData) {
              this.setState({showTrends: !showTrends});
              this.props.fetchTrendData();
            }
          }}
        />
        <Popover
          open={showTrends}
          canAutoPosition={true}
          useLayerForClickAway={true}
          anchorEl={this.iconRef}
          anchorOrigin={{horizontal: 'middle', vertical: 'top'}}
          targetOrigin={{horizontal: 'middle', vertical: 'bottom'}}
          className="skill-popover destyle-popover"
          onRequestClose={() => this.setState({showTrends: false})}>
          <div className="tooltip-container">
            <div className="ev-tooltip">
              <div className="tooltip-content">{trendChart}</div>
            </div>
          </div>
        </Popover>
      </div>
    );
  }
}
